import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toggleUiComponentBooleanState } from '../../ducks/UI.duck';

export const useBottomBarToggler = () => {
    const dispatch = useDispatch();

    const toggleBottomMobileBarVisibility = fieldState =>
        dispatch(toggleUiComponentBooleanState(['bottomMobileBarVisible', fieldState]));

    useEffect(() => {
        toggleBottomMobileBarVisibility(false);
        return () => toggleBottomMobileBarVisibility(true);
    }, []);
};
